import type { StyledComponent } from '@emotion/styled';
import { IconButton, IconButtonProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FC } from 'react';

type HelixIconButtonProps = IconButtonProps;

const HelixIconButtonRoot: FC<HelixIconButtonProps> = ({
  children,
  // I don't want to rely on the theme here because this component is separate from a MUI IconButton
  color = 'yellow',
  size = 'large',
  ...iconButtonProps
}) => {
  return (
    <IconButton color={color} size={size} {...iconButtonProps}>
      {children}
    </IconButton>
  );
};

const HelixIconButton: StyledComponent<HelixIconButtonProps> = styled(HelixIconButtonRoot)<HelixIconButtonProps>(
  (props) => {
    const { theme, color = 'yellow' } = props;
    const parsedColor = color === 'default' ? 'primary' : color;
    const mainColor = parsedColor === 'inherit' ? 'inherit' : theme.palette[parsedColor].main;
    const darkColor = parsedColor === 'inherit' ? 'inherit' : theme.palette[parsedColor].dark;
    const smallButtonSize = 4.5;
    const largeButtonSize = 6;
    return {
      color: theme.palette.text.primary,
      // This backgroundColor is causing issues on the Add A Dog flows IconButton
      backgroundColor: mainColor,
      borderRadius: theme.spacing(4),
      '&.Mui-disabled': {
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.action.disabledBackground,
      },
      '&:hover': {
        // This backgroundColor is causing issues on the Add A Dog flows IconButton
        backgroundColor: darkColor,
      },
      '&:focus': {
        backgroundColor: darkColor,
      },
      '&.MuiIconButton-sizeSmall': {
        width: theme.spacing(smallButtonSize),
        height: theme.spacing(smallButtonSize),
      },
      '&.MuiIconButton-sizeSmall .MuiSvgIcon-root': {
        width: theme.spacing(smallButtonSize / 2),
        height: theme.spacing(smallButtonSize / 2),
      },
      '&.MuiIconButton-sizeLarge': {
        width: theme.spacing(largeButtonSize),
        height: theme.spacing(largeButtonSize),
      },
      '&.MuiIconButton-sizeLarge .MuiSvgIcon-root': {
        width: theme.spacing(largeButtonSize / 2),
        height: theme.spacing(largeButtonSize / 2),
      },
    };
  }
);

export { HelixIconButton as default, HelixIconButton };
export type { HelixIconButtonProps };
